import React from 'react';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { MenuItem, Popover } from '@material-ui/core';
import { makeStyles } from 'design-system/styles';
import { INamedEntityRecognitionRelationship } from './namedEntityRecognitionAnnotations';
import NERLinkText from './NERLinkText';
import { IColorMap } from './namedEntityRecognitionLabels';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextButton } from 'react-scale/components/design-system';
import ReactTooltip from 'react-tooltip';

interface INERLinkPopoverProps {
  anchorX: number;
  anchorY: number;
  currentRelationshipId?: string;
  validRelationships: INamedEntityRecognitionRelationship[];
  labelColormap: IColorMap;
  onSetRelationship: (
    relationship: INamedEntityRecognitionRelationship,
    currentRelationshipId?: string,
  ) => void;
  onClose: () => void;
  toggleRelationshipVisibility: (id: string) => void;
}

const NERLinkPopover: React.ForwardRefRenderFunction<HTMLElement, INERLinkPopoverProps> = (
  {
    anchorX,
    anchorY,
    currentRelationshipId,
    validRelationships,
    labelColormap,
    onSetRelationship,
    onClose,
    toggleRelationshipVisibility,
  },
  containerRef: $FIXME,
) => {
  const classes = useNERLinkPopoverClasses();

  return (
    <Popover
      anchorEl={containerRef.current}
      anchorOrigin={{ horizontal: anchorX, vertical: anchorY }}
      transformOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      open={containerRef.current}
      onClose={onClose}
      className={classes.container}
    >
      {validRelationships.map(relationship => (
        <MenuItem
          key={relationship.id}
          onClick={() => onSetRelationship(relationship, currentRelationshipId)}
        >
          <NERLinkText
            sourceAnnotation={relationship.sourceAnnotation}
            targetAnnotation={relationship.targetAnnotation}
            displayName={relationship.relationshipDefinition.display_name}
            labelColormap={labelColormap}
          />
          <div data-for={`hide-${relationship.id}`} data-tip="Hide">
            <TextButton
              classes={{ root: classes.iconButton }}
              onClick={() => toggleRelationshipVisibility(relationship.id)}
            >
              <FontAwesomeIcon icon="eye-slash" className={classes.visibleIcon} />
            </TextButton>
          </div>
          <ReactTooltip id={`hide-${relationship.id}`} />
        </MenuItem>
      ))}
    </Popover>
  );
};

const useNERLinkPopoverClasses = makeStyles({
  container: {
    paddingTop: 8,
    paddingBottom: 8,
  },

  visibleIcon: {
    width: '25px !important',
    height: '25px !important',
    padding: 2,
    color: 'grey',
    marginLeft: 2,
  },

  iconButton: {
    width: 'unset !important',
    height: 'unset !important',
    minWidth: 'unset !important',
    padding: 'unset !important',
    marginLeft: 'auto',
    borderRadius: 4,
  },
});

export default React.forwardRef(NERLinkPopover);
